import { useEffect, useRef, useState } from "react";

const ImagesMessage = ({ message }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isZoomed, setIsZoomed] = useState(false);
  const modalRef = useRef(null);

  const media = Array.isArray(message?.media)
    ? message.media
    : message?.media
    ? [message.media]
    : [];

  const openModal = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);
    setIsZoomed(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsZoomed(false);
  };

  const handleModalClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      handleClose();
    }
  };

  const handleDoubleClick = () => {
    setIsZoomed((prev) => !prev);
  };

  const showNext = () => {
    setCurrentIndex((prev) => (prev + 1) % media.length);
    setIsZoomed(false);
  };

  const showPrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? media.length - 1 : prev - 1
    );
    setIsZoomed(false);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;

      if (e.key === "ArrowRight") {
        showNext();
      } else if (e.key === "ArrowLeft") {
        showPrev();
      } else if (e.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, media.length, currentIndex]);

  return (
    <>
      <div className="flex flex-wrap gap-2">
        {media.slice(0, 2).map((img, index) => (
          <div
            key={index}
            className={`relative ${
              media?.length === 1
                ? "w-full"
                : "w-[48%]"
            }`}
          >
            <img
              src={img?.file}
              alt={`image-${index}`}
              onClick={() => openModal(index)}
              className="rounded-lg cursor-pointer object-cover w-full h-40"
            />
            {index == 1 && media?.length > 2 && (
              <div
                onClick={() => openModal(index)}
                className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white text-xl font-semibold rounded-lg cursor-pointer"
              >
                +{media.length - 1} more
              </div>
            )}
          </div>
        ))}
      </div>

      {message?.message && <div className="mt-2">{message?.message}</div>}

      {/* Modal */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
          onClick={handleModalClick}
        >
          <div
            ref={modalRef}
            className="relative flex items-center justify-center"
          >
            {media?.length > 1 && <button
              onClick={showPrev}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 
                        text-black bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-md"
            >
              ◀
            </button>}
            <img
              src={media[currentIndex]?.file}
              alt={`Zoomed ${currentIndex}`}
              onDoubleClick={handleDoubleClick}
              className={`modal-content max-h-[90vh] max-w-[90vw] rounded-lg transform transition-transform duration-300 ${
                isZoomed ? "scale-150 cursor-zoom-out" : "scale-100 cursor-zoom-in"
              }`}
            />
            {media?.length > 1 && <button
              onClick={showNext}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 
                        text-black bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-md"
            >
              ▶
            </button>}
            {/* show count */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white bg-black p-2 rounded-lg shadow-md">
              {currentIndex + 1} / {media.length}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ImagesMessage;
